import React, { Component } from "react"
import ReactDOM from "react-dom"
import { translate } from "react-translate"

import { connect } from "react-redux"

import { addName, addUserName } from "../../../redux/actions/AppAction"

//IMPORT STYLE

//IMPORT IMAGES
import ExtensionsNews from "../../../assets/svg/ExtensionsNews.svg"
import ParametresNew from "../../../assets/svg/ParametresNew.svg"
import hommeShapeWhite from "../../../assets/icons/homme-shape-white.png"
import hommeShapeGrey from "../../../assets/icons/homme-shape-grey.png"
import femmeShapeGrey from "../../../assets/icons/femme-shape-grey.png"
import femmeShapeWhite from "../../../assets/icons/femme-shape-white.png"
import particulierWhite from "../../../assets/icons/particulier-white.png"
import particulierGrey from "../../../assets/icons/particulier-grey.png"
import professionelGrey from "../../../assets/icons/professionel-grey.png"
import professionelWhite from "../../../assets/icons/professionel-white.png"

import API from "../../../services/api"

//IMPORT REACT COMPONENTS

//IMPORT REDUX

//IMPORT SEMANTIC COMPONENTS
import {
  Button,
  Container,
  Segment,
  Menu,
  Image,
  Dropdown,
  Header,
  List,
  Grid,
  Search,
  Advertisement,
  Icon,
  Divider,
  Table,
  Input,
  Select,
  Item,
  Form,
  Label
} from "semantic-ui-react"
import "./parametres.css"

import { Currencies } from "../../../constants/Currencies"

const mapStateToProps = state => ({
  app: state.app
})

const CurrenciesWithCode = []
for (var i = 0; i < Currencies.length; i++) {
  // Currencies[i]
  let actualCurrency = JSON.parse(JSON.stringify(Currencies[i]))
  actualCurrency.text += " (" + actualCurrency.value + ")"
  CurrenciesWithCode.push(actualCurrency)
}

const mapActionToProps = {
  addName: addName,
  addUserName: addUserName
}

class ConnectedParametresComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: "",
      response: null,
      email: null,
      country: null,
      unit: null,
      oldpass: null,
      newpass: null,
      responseCountry: null,
      gender: null,
      userType: null,
      name: null,
      countryId: null,
      userCurrency: null,
      userUnit: null,
      result: null,
      selectedOption: "",
      responseCurrency: null,
      responseUnit: null,
      responseGender: null,
      responseUserType: null,
      updateResponseCode: null,
      authMode: null
    }
    const { t } = this.props

    this.Units = [
      { key: "Meter", text: t("meter"), value: "Meter" },
      { key: "Impérial", text: t("imperial"), value: "Imperial" }
    ]

    this.handleSubmitChangepass = this.handleSubmitChangepass.bind(this)
    this.handleClickUserType = this.handleClickUserType.bind(this)
    this.handleClickGender = this.handleClickGender.bind(this)
    this.handleClickCurrencies = this.handleClickCurrencies.bind(this)
    this.handleChangeUnits = this.handleChangeUnits.bind(this)
    this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this)
    this.handleChangeName = this.handleChangeName.bind(this)

    this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this)
    this.handleChangeOldPassword = this.handleChangeOldPassword.bind(this)

    this.setName = this.setName.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  setName(name) {
    this.props.addName(name)
  }

  componentDidMount() {
    this.setState({ redirectToReferrer: true })

    var pwd = this
    API.getCountries(this.props.app.token, { lang: this.props.app.lang }).then(
      res => {
        var response = res.data
        let tmp = []
        Object.entries(response).map((key, mainindex) => {
          if (key[0] === "countries") {
            Object.entries(key[1]).map((key, mainindex) => {
              var countries = {}
              countries.key = key[1].pkuid
              countries.text = key[1].name
              countries.value = key[1].name
              tmp.push(countries)
            })
          }
        })
        pwd.setState({
          responseCountry: tmp
        })

        API.getUser(pwd.props.app.token).then(res => {
          let response = res.data
          let tmpResponseCurrencies = Currencies.filter(
            currency => currency.value == response.currency
          )
          let tmpResponseUnit = pwd.Units.filter(
            unit => unit.value == response.unit
          )
          let tmpResponseCountry = pwd.state.responseCountry.filter(
            country => country.key === response.pkuid_country
          )
          pwd.setState({
            country:
              tmpResponseCountry.length > 0 ? tmpResponseCountry[0].text : null,
            name: response.fullname,
            responseCurrency:
              tmpResponseCurrencies.length > 0
                ? tmpResponseCurrencies[0].text
                : null,
            responseUnit:
              tmpResponseUnit.length > 0 ? tmpResponseUnit[0].text : null,
            responseGender: response.gender,
            responseUserType: response.type,
            authMode: response.mode
          })
        })
      },
      err => {
        pwd.setState({
          error: err.error
        })
      }
    )

    let token = localStorage.getItem("USER_TOKEN")

    var base64Url = token.split(".")[1]
    var base64 = base64Url.replace("-", "+").replace("_", "/")
    var tmp = JSON.parse(window.atob(base64))

    let id = tmp["id"]
    let lang = tmp["language"]
    let emailo = tmp["username"]
    let unit = tmp["unit"]
    this.setState({
      email: emailo,
      userUnit: unit
    })
  }

  handleChange(e, data) {
    let countryId
    Object.entries(this.state.responseCountry).map((key, mainindex) => {
      if (key[1].text === data.value) {
        countryId = key[1].key
      }
    })
    this.setState({
      countryId: countryId,
      country: data.value
    })
  }

  handleSubmitChangepass() {
    var pwd = this
    var changePassData = {
      email: this.state.email,
      oldpass: this.state.oldpass,
      newpass: this.state.newpass
    }
    API.changePass(this.props.app.token, changePassData).then(res => {
      pwd.setState({
        updateResponseCode:
          this.state.updateResponseCode == 200
            ? res.data.code
            : this.state.updateResponseCode
      })
    })
  }

  handleSubmitUpdate() {
    var form = new FormData()
    form.append("fkuiduser", this.props.app.id)
    if (
      this.props.app.lang !== undefined &&
      this.props.app.lang !== null &&
      this.props.app.lang !== ""
    ) {
      form.append("lang", this.props.app.lang)
    }

    if (
      this.state.userType !== undefined &&
      this.state.userType !== null &&
      this.state.userType !== ""
    ) {
      form.append("user_type", this.state.userType)
    }

    if (
      this.state.gender !== undefined &&
      this.state.gender !== null &&
      this.state.gender !== ""
    ) {
      form.append("gender", this.state.gender)
    }

    if (
      this.state.name !== undefined &&
      this.state.name !== null &&
      this.state.name !== ""
    ) {
      form.append("fullname", this.state.name)
    }

    if (
      this.state.countryId !== undefined &&
      this.state.countryId !== null &&
      this.state.countryId !== ""
    ) {
      form.append("country_id", this.state.countryId)
    }

    if (
      this.state.userUnit !== undefined &&
      this.state.userUnit !== null &&
      this.state.userUnit !== ""
    ) {
      form.append("user_unit", this.state.userUnit)
    }

    if (
      this.state.userCurrency !== undefined &&
      this.state.userCurrency !== null &&
      this.state.userCurrency !== ""
    ) {
      form.append("user_currency", this.state.userCurrency)
    }

    API.updateUser(this.props.app.token, form).then(res => {
      this.setState({
        updateResponseCode: res.data.code
      })
    })

    if (
      this.state.newpass !== undefined &&
      this.state.newpass !== null &&
      this.state.newpass !== ""
    ) {
      this.handleSubmitChangepass()
    }
  }

  handleClickCurrencies(e, data) {
    e.preventDefault()
    this.setState({
      userCurrency: data.value
    })
  }

  handleChangeUnits(e, data) {
    e.preventDefault()

    this.setState({
      userUnit: data.value
    })
  }

  handleClickGender(e) {
    e.preventDefault()

    let value =
      e.target.value != undefined
        ? e.target.value
        : e.target.getAttribute("value")

    let tmp = false
    if (value == 1) {
      tmp = true
    }

    this.setState({
      gender: value,
      responseGender: tmp
    })
  }

  handleClickUserType(e) {
    e.preventDefault()

    let value =
      e.target.value != undefined
        ? e.target.value
        : e.target.getAttribute("value")

    let tmp = false
    if (value == 1) {
      tmp = true
    }

    this.setState({
      userType: value,
      responseUserType: tmp
    })
  }

  handleChangeOldPassword(event) {
    this.setState({
      oldpass: event.target.value
    })
  }

  handleChangeNewPassword(event) {
    this.setState({
      newpass: event.target.value
    })
  }

  handleChangeGender(event) {
    this.setState({ gender: event.target.value })
  }

  handleChangeUserType(event) {
    this.setState({ userType: event.target.value })
  }

  handleChangeName(event) {
    this.setState({
      name: event.target.value
    })
    this.setName(this.state.name)
    localStorage.setItem("name", this.state.name)
  }

  render() {
    var stylos = {
      backgroundColor: "#d1d1d1"
    }

    const { t } = this.props

    const { selectedOption } = this.state
    const value = selectedOption && selectedOption.value

    return (
      <div>
        <div>
          <div>
            {this.state.response &&
              Object.entries(this.state.response).map((key, mainindex) => {
                return (
                  <li>
                    {key[1].id}
                    <br />
                    {key[1].pkuid}
                    {key[1].name}
                  </li>
                )
              })}
          </div>
          <Grid stackable id="parameters">
            <Grid.Row columns={1} id="headerSection">
              <Grid.Column width={5}>
                <Segment basic>
                  <Item.Image
                    size="mini"
                    src={ParametresNew}
                    id="imageSection"
                  />
                  <Item.Content verticalAlign="middle">
                    <Item.Header as="h3" id="titleSection">
                      {t("Item1_title")}
                    </Item.Header>
                  </Item.Content>
                </Segment>
              </Grid.Column>
              <Divider />
            </Grid.Row>
            <Grid.Row>
              <Grid.Column style={{ paddingLeft: "2.5em" }}>
                <Item.Header
                  as="h3"
                  id="titleSubSection"
                  style={{ marginTop: "20px" }}
                >
                  {t("Item2_title")}
                </Item.Header>
              </Grid.Column>
            </Grid.Row>
            <Container
              textAlign="center"
              style={{ paddingRight: "2.5em", paddingLeft: "2.5em" }}
            >
              <Segment style={{ borderRadius: "10px" }}>
                <Grid stackable>
                  <Grid.Row columns={2} verticalAlign>
                    <Grid.Column textAlign="left">
                      <Item.Header as="h4">
                        {t("Item3_title")}
                        <br />
                      </Item.Header>
                      <Form>
                        <input
                          onChange={this.handleChangeName}
                          value={this.state.name}
                          type="text"
                          className="inputParameters"
                        />
                      </Form>
                    </Grid.Column>
                    <Grid.Column textAlign="left">
                      <Item.Group>
                        <Item.Header as="h4">{t("Item4_title")}</Item.Header>
                        <Item>
                          <Image.Group>
                            {this.state.responseGender ? (
                              <div>
                                <Button
                                  onClick={this.handleClickGender}
                                  value={1}
                                  size="big"
                                  className="btnPicto"
                                  style={{
                                    backgroundColor: "#0964c1",
                                    color: "#fff"
                                  }}
                                >
                                  <Image value={1} src={hommeShapeWhite} />{" "}
                                  {t("male")}
                                </Button>
                                <Button
                                  onClick={this.handleClickGender}
                                  value={0}
                                  size="big"
                                  className="btnPicto"
                                >
                                  <Image value={0} src={femmeShapeGrey} />{" "}
                                  {t("female")}
                                </Button>
                              </div>
                            ) : (
                              <div>
                                <Button
                                  onClick={this.handleClickGender}
                                  value={1}
                                  size="big"
                                  className="btnPicto"
                                >
                                  <Image value={1} src={hommeShapeGrey} />{" "}
                                  {t("male")}
                                </Button>
                                <Button
                                  onClick={this.handleClickGender}
                                  value={0}
                                  size="big"
                                  className="btnPicto"
                                  style={{
                                    backgroundColor: "#0964c1",
                                    color: "#fff"
                                  }}
                                >
                                  <Image value={0} src={femmeShapeWhite} />{" "}
                                  {t("female")}
                                </Button>
                              </div>
                            )}
                          </Image.Group>
                        </Item>
                      </Item.Group>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column textAlign="left">
                      <Item.Header
                        as="h4"
                        style={{ color: "rgb(114,114,114)" }}
                      >
                        {t("Item5_title")}
                        <br />
                      </Item.Header>
                      <Form>
                        <input
                          disabled
                          type="text"
                          placeholder={this.state.email}
                          className="inputParameters"
                        />
                      </Form>
                    </Grid.Column>

                    <Grid.Column textAlign="left">
                      <Item.Group>
                        <Item.Header as="h4">{t("Item11_title")}</Item.Header>
                        <Item>
                          <Image.Group>
                            {!this.state.responseUserType ? (
                              <div>
                                <Button
                                  onClick={this.handleClickUserType}
                                  value={0}
                                  size="big"
                                  className="btnPicto"
                                  style={{
                                    backgroundColor: "#0964c1",
                                    color: "#fff"
                                  }}
                                >
                                  <Image value={0} src={particulierWhite} />{" "}
                                  {t("particulier")}
                                </Button>
                                <Button
                                  onClick={this.handleClickUserType}
                                  value={1}
                                  size="big"
                                  className="btnPicto"
                                >
                                  <Image value={1} src={professionelGrey} />{" "}
                                  {t("professional")}
                                </Button>
                              </div>
                            ) : (
                              <div>
                                <Button
                                  onClick={this.handleClickUserType}
                                  value={0}
                                  size="big"
                                  className="btnPicto"
                                >
                                  <Image value={0} src={particulierGrey} />{" "}
                                  {t("particulier")}
                                </Button>
                                <Button
                                  onClick={this.handleClickUserType}
                                  value={1}
                                  size="big"
                                  className="btnPicto"
                                  style={{
                                    backgroundColor: "#0964c1",
                                    color: "#fff"
                                  }}
                                >
                                  <Image value={1} src={professionelWhite} />{" "}
                                  {t("professional")}
                                </Button>
                              </div>
                            )}
                          </Image.Group>
                        </Item>
                      </Item.Group>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row columns={2} verticalAlign="center">
                    <Grid.Column textAlign="left">
                      <Item.Header as="h4">
                        {t("Item7_title")}
                        <br />
                      </Item.Header>
                      <Select
                        placeholder={this.state.responseCurrency}
                        onChange={this.handleClickCurrencies}
                        options={CurrenciesWithCode}
                        className="selectParameters"
                      />
                    </Grid.Column>
                    <Grid.Column textAlign="left">
                      <Item.Header as="h4">
                        {t("Item8_title")}
                        <br />
                      </Item.Header>
                      <Select
                        placeholder={this.state.responseUnit}
                        selection
                        onChange={this.handleChangeUnits}
                        options={[
                          { key: "Meter", text: t("meter"), value: "Meter" },
                          {
                            key: "Impérial",
                            text: t("imperial"),
                            value: "Imperial"
                          }
                        ]}
                        className="selectParameters"
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row columns={2} verticalAlign="center">
                    <Grid.Column textAlign="left">
                      <Item.Header as="h4">
                        {t("Item6_title")}
                        <br />
                      </Item.Header>
                      <Dropdown
                        selection
                        search
                        value={this.state.country}
                        onChange={this.handleChange}
                        options={this.state.responseCountry}
                        className="selectParameters"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  {this.state.authMode !== "INT" ? (
                    <div />
                  ) : (
                    <Grid.Row columns={2} verticalAlign="center">
                      <Grid.Column textAlign="left">
                        <Item.Header as="h4">
                          {t("Item9_title")}
                          <br />
                        </Item.Header>
                        <Form>
                          <input
                            type="password"
                            onChange={this.handleChangeOldPassword}
                            placeholder={t("Item9_title")}
                            className="inputParameters"
                          />
                        </Form>
                      </Grid.Column>

                      <Grid.Column textAlign="left">
                        <Item.Header as="h4">
                          {t("Item10_title")}
                          <br />
                        </Item.Header>
                        <Form>
                          <input
                            type="password"
                            onChange={this.handleChangeNewPassword}
                            placeholder={t("Item10_title")}
                            className="inputParameters"
                          />
                        </Form>
                      </Grid.Column>
                    </Grid.Row>
                  )}
                </Grid>
              </Segment>
            </Container>
            <Grid.Row
              columns={1}
              style={{ marginBottom: "10px", paddingLeft: "2.5em" }}
            >
              <Grid.Column style={{ paddingLeft: "0" }}>
                <Button size="massive" inverted id="cancelBtn">
                  {t("cancel")}
                </Button>
                <Button
                  onClick={this.handleSubmitUpdate}
                  size="massive"
                  inverted
                  id="validBtn"
                >
                  {t("register")}
                </Button>
                {this.state.updateResponseCode == null ? (
                  <div />
                ) : this.state.updateResponseCode == 200 ? (
                  <Segment
                    inverted
                    className="greenColor"
                    id="infoMessageParameters"
                  >
                    {t("maj_ok")}
                  </Segment>
                ) : (
                  <Segment
                    inverted
                    color="red"
                    tertiary
                    id="infoMessageParameters"
                  >
                    {t("maj_ko")}
                  </Segment>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    )
  }
}

const ParametresComponent = connect(
  mapStateToProps,
  mapActionToProps
)(ConnectedParametresComponent)
export default translate("ParametresComponent")(ParametresComponent)



// WEBPACK FOOTER //
// ./src/components/Protected/Parametre/ParametresComponent.js